import { createApi } from '@reduxjs/toolkit/dist/query/react';

import { baseQueryWithIntercept } from '@apis/fetchBaseQuery';
import {
    GetTransformedPermissions,
    GetPermissionsResponse,
    REQUEST_PATH
} from '@apis/permissions/Permissions.type';
import { RequestStatusWithData } from '@customTypes/api/api.types';
import { permissionsDataTransformer } from '@helpers/profilesHelpers';

export const permissionsApi = createApi({
    reducerPath: 'permissionsApi',
    baseQuery: baseQueryWithIntercept,
    endpoints: (builder) => ({
        getPermissions: builder.query<GetTransformedPermissions[], void>({
            query: () => {
                return {
                    url: REQUEST_PATH.GET_PERMISSIONS,
                    method: 'GET'
                };
            },
            transformResponse: (
                response: RequestStatusWithData<GetPermissionsResponse>
            ): GetTransformedPermissions[] => {
                return permissionsDataTransformer(
                    response.data.groups,
                    response.data.permissions
                );
            }
        })
    })
});

export const { useGetPermissionsQuery } = permissionsApi;
